import { useQuery } from '@tanstack/react-query';

import { validateAskToJoinLink } from '@/api/v4/user.api';
import { QueryKey } from '@/config/query-client';

export const useValidateAskToJoinLink = (linkId: string) => {
  return useQuery({
    queryKey: [QueryKey.AskToJoinLink, 'validate', linkId],
    queryFn: () => validateAskToJoinLink({ linkId }),
    enabled: !!linkId,
    retry: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  });
};
